import { SoftwarePlatform } from './software-platform';
var SoftwareType = (function () {
    function SoftwareType(items, language) {
        if (items === void 0) { items = []; }
        if (language === void 0) { language = ''; }
        var _a;
        this.language = '';
        this.language = language;
        this.title = ((_a = items[0]) === null || _a === void 0 ? void 0 : _a.documentTypeTranslation) || '';
        this.initializePlatforms(items);
    }
    SoftwareType.prototype.initializePlatforms = function (items) {
        var _this = this;
        if (items === void 0) { items = []; }
        this.platforms = items
            .filter(function (x) { return Boolean(x.platform); })
            .map(function (x) { return x.platform; })
            .filter(function (platform, index, context) { return (context.indexOf(platform) === index); })
            .map(function (platform) {
            var platformItems = items.filter(function (softwareItem) { return (softwareItem.platform === platform); });
            return new SoftwarePlatform(platformItems, platform, _this.language);
        });
    };
    return SoftwareType;
}());
export { SoftwareType };
